import { jsx as g } from "react/jsx-runtime";
import { Slot as m } from "@radix-ui/react-slot";
import { cva as o } from "class-variance-authority";
import { forwardRef as h } from "react";
import { cn as r } from "./index23.mjs";
const s = o("", {
  variants: {
    fontFamily: {
      inter: "font-inter",
      polysans: "font-polysans"
    },
    fontSize: {
      "5xl": "text-5xl-mobile leading-[var(--text-5xl--line-height-mobile)] md:text-5xl-tablet md:leading-[var(--text-5xl--line-height-tablet)] lg:text-5xl lg:leading-[var(--text-5xl--line-height)]",
      "4xl": " text-4xl-mobile leading-[var(--text-4xl--line-height-mobile)] md:text-4xl-tablet md:leading-[var(--text-4xl--line-height-tablet)] lg:text-4xl lg:leading-[var(--text-4xl--line-height)]",
      "3xl": "text-3xl-mobile leading-[var(--text-3xl--line-height-mobile)] md:text-3xl-tablet md:leading-[var(--text-3xl--line-height-tablet)] lg:text-3xl lg:leading-[var(--text-3xl--line-height)]",
      "2xl": " text-2xl-mobile leading-[var(--text-2xl--line-height-mobile)] md:text-2xl-tablet md:leading-[var(--text-2xl--line-height-tablet)] lg:text-2xl lg:leading-[var(--text-2xl--line-height)]",
      xl: "text-xl-mobile leading-[var(--text-xl--line-height-mobile)] md:text-xl-tablet md:leading-[var(--text-xl--line-height-tablet)] lg:text-xl lg:leading-[var(--text-xl--line-height)]",
      lg: "text-lg-mobile leading-[var(--text-lg--line-height-mobile)] md:text-lg-tablet md:leading-[var(--text-lg--line-height-tablet)] lg:text-lg lg:leading-[var(--text-lg--line-height)]",
      base: "text-base-mobile leading-[var(--text-base--line-height-mobile)] md:text-base-tablet md:leading-[var(--text-base--line-height-tablet)] lg:text-base lg:leading-[var(--text-base--line-height)]",
      sm: "text-sm-mobile leading-[var(--text-sm--line-height-mobile)] md:text-sm-tablet md:leading-[var(--text-sm--line-height-tablet)] lg:text-sm lg:leading-[var(--text-sm--line-height)]",
      xs: "text-xs-mobile leading-[var(--text-xs--line-height-mobile)] md:text-xs-tablet md:leading-[var(--text-xs--line-height-tablet)] lg:text-xs lg:leading-[var(--text-xs--line-height)]"
    },
    fontWeight: {
      regular: "",
      semibold: "font-semibold",
      bold: ""
    }
  },
  compoundVariants: [
    // bold and regular are only applied to certain font-sizes and font-families
    {
      fontFamily: "inter",
      fontSize: ["lg", "base", "sm", "xs"],
      fontWeight: "bold",
      class: "font-bold"
    },
    {
      fontFamily: ["inter", "polysans"],
      fontSize: ["2xl", "xl", "lg", "base", "sm", "xs"],
      fontWeight: "regular",
      class: "font-normal"
    }
  ],
  defaultVariants: {
    fontFamily: "inter",
    fontSize: "base",
    fontWeight: "semibold"
  }
}), d = h(
  ({ className: t, children: e, asChild: l = !1, fontWeight: i = "semibold", fontSize: a = "base", fontFamily: x = "inter" }, n) => /* @__PURE__ */ g(l ? m : "p", { ref: n, className: r(s({ fontFamily: x, fontSize: a, fontWeight: i, className: t })), children: e })
);
d.displayName = "Text";
export {
  d as Text
};
